export default __webpack_public_path__ + "static/media/kevin_zhu.f9874913.png";